import { AiOutlinePlus } from "react-icons/ai"; 
import React, {useState} from 'react';
import { BiTrash } from "react-icons/bi"; 
import { BiEditAlt } from "react-icons/bi"; 
import '../css/MembersTable.css';
import {SubscribersList} from '../Data/subcribers';
import AbonneForm from '../forms/AbonneForm';
import EditAbonneForm from './../forms/edits/EditAbonneForm';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';



function Subscribers() {

  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [showModal, setShowModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedAbonne, setSelectedAbonne] = useState({});


  const filteredData = SubscribersList.filter((abonne) => {
    return abonne.nomComplet.toLowerCase().includes(searchTerm.toLowerCase());
  });

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const handleAddNew = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleEditAbonne = (abonne) => {
    setSelectedAbonne(abonne);
    setShowEditModal(true);
  };

  const handleCloseEditModal = () => {
    setShowEditModal(false);
  };

  const handleUpdateAbonne = (updatedAbonne) => {
    const updatedList = SubscribersList.map((abonne) => {
      if (abonne.nomComplet === selectedAbonne.nomComplet) {
        return updatedAbonne;
      }
      return abonne;
    });

    setShowEditModal(false);
  };

  const handleDeleteAbonne = (abonne) => {
    if (window.confirm(`Voulez-vous vraiment supprimer l'abonné ${abonne.nomComplet} ?`)) {
      // Code pour supprimer l'abonné
      toast.success(`L'abonné ${abonne.nomComplet} a été supprimé avec succès !`);
    }
  };
  

  return (
    <div className="container mx-auto p-4">
      <div className="flex justify-between items-center mb-4">
        <h1 className="text-lg font-bold">Liste des abonnées</h1>
        <div className="flex gap-2">
          <button className="btn-primary" onClick={handleAddNew}><AiOutlinePlus /> Ajouter abonné</button>
          <button className="btn-secondary">Export abonnes (Excel)</button>
          <input
            type="text"
            placeholder="Rechercher un abonné..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="search-bar"
          />
        </div>
      </div>

      <table className="table-auto w-full border-collapse border border-gray-300">
        <thead>
          <tr className="bg-gray-100">
            <th className="border border-gray-300 px-4 py-2">Nom Complet</th>
            <th className="border border-gray-300 px-4 py-2">Mobile</th>
            <th className="border border-gray-300 px-4 py-2">Type de carte</th>
            <th className="border border-gray-300 px-4 py-2">Structure</th>
            <th className="border border-gray-300 px-4 py-2">Status</th>
            <th className="border border-gray-300 px-4 py-2">Operation</th>
          </tr>
        </thead>
        <tbody>
        {currentItems.map((abonne, index) => (
            <tr key={index} className="text-center">
              <td className="border border-gray-300 px-4 py-2">{abonne.nomComplet}</td>
              <td className="border border-gray-300 px-4 py-2">{abonne.telephone}</td>
              <td className="border border-gray-300 px-4 py-2">{abonne.typeCarte}</td>
              <td className="border border-gray-300 px-4 py-2">{abonne.structure}</td>
              <td
                className={`border border-gray-300 px-4 py-2 ${
                  abonne.Etat === "actif" ? "text-green-500" : "text-red-500"
                }`}
              >
                {abonne.Etat}
              </td>
              <td className="border border-gray-300 px-4 py-2">
                <button className="text-blue-500 mx-1" onClick={() =>  handleEditAbonne(abonne)}><BiEditAlt /></button>
                <button className="text-red-500 mx-1" onClick={() => handleDeleteAbonne(abonne)}><BiTrash /></button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className="pagination">
        {Array.from(
          { length: Math.ceil(filteredData.length / itemsPerPage) },
          (_, i) => (
            <button
              key={i + 1}
              onClick={() => paginate(i + 1)}
              className={currentPage === i + 1 ? "active" : ""}
            >
              {i + 1}
            </button>
          )
        )}
      </div>

      {showModal && (
        <div className="modal">
          <div className="modal-content">
            <button className="close-button" onClick={handleCloseModal}>
              &times;
            </button>
            <AbonneForm />
          </div>
        </div>
      )}


{showEditModal && (
        <div className="modal">
          <div className="modal-content">
            <button className="close-button" onClick={handleCloseEditModal}>
              &times;
            </button>
            <EditAbonneForm abonne={selectedAbonne} handleUpdateAbonne={handleUpdateAbonne}/>
          </div>
        </div>
      )}
    </div>
  )
}

export default Subscribers